import React from 'react';
import { Box } from '@mui/material';
import { BannerInfoTransaccionesIa } from './components/BannerInfoTransaccionesIa';
import { hasPemissions } from 'commons/utils';
import { PageLayout } from 'components/generics/PageLayout';
import { TableTransaccionesIa } from './components/TableTransaccionesIa';

export const TransaccionesIa = () => {
    const [canView, setCanView] = React.useState(false);

    const checkPermissions = async () => {
        const view = await hasPemissions('modulo.manager', 'modulo.manager.plataforma.ia', 'view', 'modulo.manager.plataforma.ia.comercial', 'modulo.manager.plataforma.ia.comercial.transacciones');
        setCanView(view);
    };

    React.useEffect(() => {
        checkPermissions();
    }, []);

    return (
        <PageLayout
            title="Transacciones de Créditos"
            mainModule="Plataforma IA"
            icon="ReceiptLong"
            infoAlert="Auditoría e historial de transacciones de créditos de las suscripciones de los clientes."
            actionButtons={<></>}
        >
            <TableTransaccionesIa />
            <BannerInfoTransaccionesIa />
        </PageLayout>
    );
};
